import { createActionConst } from '../../../utils/action.utils';

const USER_PAGE_NAMESPACE = 'USER_PAGE';

export const INITIAL_USER_PAGE = createActionConst(USER_PAGE_NAMESPACE, 'INITIAL_USER_PAGE');
